/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-27 11:04:11
 * @LastEditors: caiqin.xie
 * @message: 产品支持-产品banner
 */
import React, {useState} from "react";
import BlogItem from "../../../../blog/components/BlogItem";
import styles from "../../index.module.scss";
import { IBlogItem } from "@/common/types";

interface IProps {
  ctry: string;
  words: Record<string, string>;
  blogList: IBlogItem[]; // 列表
  pages: number; // 总页数
  getBlogList: (pageNum: number) => void; // 获取列表
}

const PopularForums = (props:IProps) => {
  const {ctry, words, blogList, pages, getBlogList} = props
  const [pageNum, setPageNum] = useState(1); // 当前页数
  // 加载更多
  const handleClick = () => {
    const currentPage = pageNum + 1;
    getBlogList(currentPage);
    setPageNum(currentPage);
  }
  return (
    <>
      {blogList && blogList.length > 0 && (
        <section className={styles['product-section']}>
          <h2 className={styles['product-section-title']}>{words?.support_product_popular_forums_title}</h2>
          {/* Popular forums */}
          <div className={styles['popular-forums-list']}>
            {blogList && blogList.map((item,index) => (
              // 数据来源为Popular forums模块的数据
              <a
                href={`/${ctry}/support/popular-forums/${item.seoUrl}`}
                target="_blank"
                key={item.id}
                className={styles['link-blog']}>
                <BlogItem type="onlyTitle" blogData={item}
                  className={styles['custom-blog']}
                  picClassName={styles['custom-blog-pic']} />
              </a>
            ))}
          </div>
          {pages > pageNum && (
            <p className={styles['load-more']}>
              <span className={styles['load-more-btn']} onClick={handleClick}>{words?.common_load_more}</span>
              {/* Load More */}
            </p>
          )}
        </section>
      )}
    </>

  )
}
export default PopularForums
